// src/modelBuilder.ts
function buildModelFromPackages(packages) {
  const allPartDefs = [];
  const allPartUsages = [];
  const allActionDefs = [];
  const allActionUsages = [];
  const allPerforms = [];
  const allFlows = [];
  const allPortDefs = [];
  const allItemDefs = [];
  const allPorts = [];
  const allProps = [];
  const allStateDefs = [];
  const allStateUsages = [];
  const allTransitions = [];
  const allRequirementDefs = [];
  const allRequirementUsages = [];
  const allSatisfies = [];
  const allConstraintDefs = [];
  const allConstraintUsages = [];
  const allAsserts = [];
  const allConnectionDefs = [];
  const allConnections = [];
  const allAllocationDefs = [];
  const allAllocations = [];
  const allUseCaseDefs = [];
  const allUseCaseUsages = [];
  const allActorUsages = [];
  const allIncludeUseCases = [];
  const allInterfaceDefs = [];
  const allInterfaceUsages = [];
  const allVerificationDefs = [];
  const allVerificationUsages = [];
  const allAnalysisDefs = [];
  const allAnalysisUsages = [];
  const allCalcDefs = [];
  const allCalcUsages = [];
  const allViewpointDefs = [];
  const allViewpointUsages = [];
  const allRenderingDefs = [];
  const allRenderingUsages = [];
  const allMetadataDefs = [];
  const allOccurrenceDefs = [];
  const allOccurrenceUsages = [];
  const allEnums = [];
  const allTypeAliases = [];
  const allLets = [];
  const allImports = [];
  const allRelationships = [];
  const allViews = [];
  const allRules = [];
  const allElements = [];
  const collectFromPackage = (pkg) => {
    allElements.push(pkg);
    for (const pd of pkg.partDefs) {
      allPartDefs.push(pd);
      allElements.push(pd);
      allPartUsages.push(...pd.parts);
      allElements.push(...pd.parts);
      if (pd.ports?.length) {
        allPorts.push(...pd.ports);
        allElements.push(...pd.ports);
      }
      if (pd.props?.length) {
        allProps.push(...pd.props);
        allElements.push(...pd.props);
      }
      if (pd.relationships?.length) {
        allRelationships.push(...pd.relationships);
        allElements.push(...pd.relationships);
      }
      if (pd.actions?.length) {
        allActionUsages.push(...pd.actions);
        allElements.push(...pd.actions);
      }
    }
    if (pkg.actionDefs?.length) {
      allActionDefs.push(...pkg.actionDefs);
      allElements.push(...pkg.actionDefs);
      for (const ad of pkg.actionDefs) {
        if (ad.actions?.length) {
          allActionUsages.push(...ad.actions);
          allElements.push(...ad.actions);
        }
        if (ad.performs?.length) {
          allPerforms.push(...ad.performs);
          allElements.push(...ad.performs);
        }
        if (ad.flows?.length) {
          allFlows.push(...ad.flows);
          allElements.push(...ad.flows);
        }
      }
    }
    if (pkg.portDefs?.length) {
      allPortDefs.push(...pkg.portDefs);
      allElements.push(...pkg.portDefs);
    }
    if (pkg.itemDefs?.length) {
      allItemDefs.push(...pkg.itemDefs);
      allElements.push(...pkg.itemDefs);
    }
    if (pkg.stateDefs?.length) {
      allStateDefs.push(...pkg.stateDefs);
      allElements.push(...pkg.stateDefs);
      for (const sd of pkg.stateDefs) {
        if (sd.states?.length) {
          allStateUsages.push(...sd.states);
          allElements.push(...sd.states);
        }
        if (sd.transitions?.length) {
          allTransitions.push(...sd.transitions);
          allElements.push(...sd.transitions);
        }
      }
    }
    if (pkg.requirementDefs?.length) {
      allRequirementDefs.push(...pkg.requirementDefs);
      allElements.push(...pkg.requirementDefs);
      for (const rd of pkg.requirementDefs) {
        if (rd.subrequirements?.length) {
          allRequirementUsages.push(...rd.subrequirements);
          allElements.push(...rd.subrequirements);
        }
        if (rd.constraints?.length) {
          allConstraintUsages.push(...rd.constraints);
          allElements.push(...rd.constraints);
        }
      }
    }
    if (pkg.constraintDefs?.length) {
      allConstraintDefs.push(...pkg.constraintDefs);
      allElements.push(...pkg.constraintDefs);
    }
    if (pkg.connectionDefs?.length) {
      allConnectionDefs.push(...pkg.connectionDefs);
      allElements.push(...pkg.connectionDefs);
    }
    if (pkg.connections?.length) {
      allConnections.push(...pkg.connections);
      allElements.push(...pkg.connections);
    }
    if (pkg.allocationDefs?.length) {
      allAllocationDefs.push(...pkg.allocationDefs);
      allElements.push(...pkg.allocationDefs);
    }
    if (pkg.allocations?.length) {
      allAllocations.push(...pkg.allocations);
      allElements.push(...pkg.allocations);
    }
    if (pkg.useCaseDefs?.length) {
      allUseCaseDefs.push(...pkg.useCaseDefs);
      allElements.push(...pkg.useCaseDefs);
      for (const uc of pkg.useCaseDefs) {
        if (uc.actors?.length) {
          allActorUsages.push(...uc.actors);
          allElements.push(...uc.actors);
        }
        if (uc.includes?.length) {
          allIncludeUseCases.push(...uc.includes);
          allElements.push(...uc.includes);
        }
      }
    }
    if (pkg.interfaceDefs?.length) {
      allInterfaceDefs.push(...pkg.interfaceDefs);
      allElements.push(...pkg.interfaceDefs);
      for (const iface of pkg.interfaceDefs) {
        if (iface.ports?.length) {
          allPorts.push(...iface.ports);
          allElements.push(...iface.ports);
        }
      }
    }
    if (pkg.verificationDefs?.length) {
      allVerificationDefs.push(...pkg.verificationDefs);
      allElements.push(...pkg.verificationDefs);
      for (const vd of pkg.verificationDefs) {
        if (vd.actions?.length) {
          allActionUsages.push(...vd.actions);
          allElements.push(...vd.actions);
        }
      }
    }
    if (pkg.analysisDefs?.length) {
      allAnalysisDefs.push(...pkg.analysisDefs);
      allElements.push(...pkg.analysisDefs);
    }
    if (pkg.calcDefs?.length) {
      allCalcDefs.push(...pkg.calcDefs);
      allElements.push(...pkg.calcDefs);
    }
    if (pkg.viewpointDefs?.length) {
      allViewpointDefs.push(...pkg.viewpointDefs);
      allElements.push(...pkg.viewpointDefs);
    }
    if (pkg.renderingDefs?.length) {
      allRenderingDefs.push(...pkg.renderingDefs);
      allElements.push(...pkg.renderingDefs);
    }
    if (pkg.metadataDefs?.length) {
      allMetadataDefs.push(...pkg.metadataDefs);
      allElements.push(...pkg.metadataDefs);
    }
    if (pkg.occurrenceDefs?.length) {
      allOccurrenceDefs.push(...pkg.occurrenceDefs);
      allElements.push(...pkg.occurrenceDefs);
    }
    if (pkg.satisfies?.length) {
      allSatisfies.push(...pkg.satisfies);
      allElements.push(...pkg.satisfies);
    }
    if (pkg.asserts?.length) {
      allAsserts.push(...pkg.asserts);
      allElements.push(...pkg.asserts);
    }
    allRelationships.push(...pkg.relationships);
    allViews.push(...pkg.views);
    allRules.push(...pkg.rules);
    allEnums.push(...pkg.enums);
    allTypeAliases.push(...pkg.typeAliases);
    allLets.push(...pkg.lets);
    allImports.push(...pkg.imports);
    allElements.push(...pkg.relationships);
    allElements.push(...pkg.views);
    allElements.push(...pkg.rules);
    allElements.push(...pkg.enums);
    allElements.push(...pkg.typeAliases);
    allElements.push(...pkg.lets);
    allElements.push(...pkg.imports);
    for (const nested of pkg.packages) {
      collectFromPackage(nested);
    }
  };
  for (const pkg of packages) {
    collectFromPackage(pkg);
  }
  return {
    packages,
    // Core
    allPartDefs,
    allPartUsages,
    allActionDefs,
    allActionUsages,
    allPerforms,
    allFlows,
    allPortDefs,
    allItemDefs,
    allPorts,
    allProps,
    // State Machine
    allStateDefs,
    allStateUsages,
    allTransitions,
    // Requirements
    allRequirementDefs,
    allRequirementUsages,
    allSatisfies,
    // Constraints
    allConstraintDefs,
    allConstraintUsages,
    allAsserts,
    // Connections
    allConnectionDefs,
    allConnections,
    // Allocations
    allAllocationDefs,
    allAllocations,
    // Use Cases
    allUseCaseDefs,
    allUseCaseUsages,
    allActorUsages,
    allIncludeUseCases,
    // Interfaces
    allInterfaceDefs,
    allInterfaceUsages,
    // Verification
    allVerificationDefs,
    allVerificationUsages,
    // Analysis
    allAnalysisDefs,
    allAnalysisUsages,
    // Calculations
    allCalcDefs,
    allCalcUsages,
    // Viewpoints & Rendering
    allViewpointDefs,
    allViewpointUsages,
    allRenderingDefs,
    allRenderingUsages,
    // Metadata & Occurrences
    allMetadataDefs,
    allOccurrenceDefs,
    allOccurrenceUsages,
    // Other
    allEnums,
    allTypeAliases,
    allLets,
    allImports,
    allRelationships,
    allViews,
    allRules,
    allElements
  };
}

// src/builderSchema.ts
var IDENTIFIER_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*$/;
var IDENTIFIER_MESSAGE = "Must start with a letter or underscore, followed by letters, numbers, or underscores";
var QUALIFIED_NAME_PATTERN = /^[A-Za-z_][A-Za-z0-9_]*(::[A-Za-z_][A-Za-z0-9_]*)*$/;
var QUALIFIED_NAME_MESSAGE = "Must be a valid identifier or qualified name (e.g., Package::Type)";
var nameField = (label = "Name", placeholder = "MyElement") => ({
  id: "name",
  label,
  type: "text",
  required: true,
  placeholder,
  pattern: IDENTIFIER_PATTERN,
  patternMessage: IDENTIFIER_MESSAGE,
  help: "A unique identifier for this element",
  bestPractice: "Use PascalCase for definitions (e.g., VehicleController), camelCase for usages (e.g., mainController)"
});
var descriptionField = {
  id: "description",
  label: "Description",
  type: "multiline",
  required: false,
  placeholder: "Describe the purpose and responsibility of this element...",
  help: "Optional documentation that appears in the model",
  bestPractice: 'Always document the "why" - what problem does this element solve?'
};
var typeRefField = (label = "Type", placeholder = "TypeName") => ({
  id: "typeRef",
  label,
  type: "typeRef",
  required: true,
  placeholder,
  pattern: QUALIFIED_NAME_PATTERN,
  patternMessage: QUALIFIED_NAME_MESSAGE,
  help: "Reference to a part definition or type",
  bestPractice: "Use fully qualified names for types from other packages"
});
var multiplicityField = {
  id: "multiplicity",
  label: "Multiplicity",
  type: "multiplicity",
  required: false,
  placeholder: "1",
  defaultValue: "1",
  help: "How many instances (e.g., 1, 0..1, 0..*, 1..*)",
  bestPractice: "Always specify multiplicity explicitly - avoid ambiguity"
};
var ELEMENT_SCHEMAS = [
  // ─────────────────────────────────────────────────────────────────────────
  // Part Definition
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "part-def",
    label: "Part Definition",
    description: "A reusable block that defines structure and behavior",
    category: "structure",
    icon: "Box",
    fields: [
      nameField("Name", "VehicleController"),
      {
        id: "stereotype",
        label: "Stereotype",
        type: "select",
        required: false,
        options: [
          { value: "", label: "None", description: "Standard part definition" },
          { value: "abstract", label: "Abstract", description: "Cannot be instantiated directly" },
          { value: "interface", label: "Interface", description: "Defines a contract" }
        ],
        help: "Optional classification of this part definition"
      },
      {
        id: "supertype",
        label: "Extends",
        type: "typeRef",
        required: false,
        placeholder: "BaseType",
        help: "Optional parent type to inherit from",
        bestPractice: "Prefer composition over inheritance when possible"
      },
      descriptionField,
      {
        id: "owner",
        label: "Owner",
        type: "text",
        required: false,
        placeholder: "TeamName",
        help: "Team or person responsible for this component",
        bestPractice: "Assign clear ownership for maintainability"
      },
      {
        id: "state",
        label: "Lifecycle State",
        type: "select",
        required: false,
        defaultValue: "draft",
        options: [
          { value: "draft", label: "Draft", description: "Work in progress" },
          { value: "active", label: "Active", description: "Production ready" },
          { value: "deprecated", label: "Deprecated", description: "Being phased out" }
        ],
        help: "Current lifecycle state of this definition"
      }
    ],
    generate: (v) => {
      const lines = [];
      const stereotype = v.stereotype ? `\xAB${v.stereotype}\xBB ` : "";
      const supertype = v.supertype ? ` :> ${v.supertype}` : "";
      lines.push(`part def ${stereotype}${v.name}${supertype} {`);
      if (v.description) {
        lines.push(`  doc /* ${v.description} */`);
      }
      if (v.owner || v.state) {
        const meta = [];
        if (v.owner) meta.push(`owner: "${v.owner}"`);
        if (v.state) meta.push(`state: "${v.state}"`);
        lines.push(`  @meta { ${meta.join(", ")} }`);
      }
      lines.push("  ");
      lines.push("}");
      return lines.join("\n");
    },
    bestPractices: [
      "Name should clearly describe what the component represents",
      "Include a description explaining the responsibility",
      "Assign ownership for maintainability tracking",
      "Keep definitions focused - one responsibility per part"
    ],
    example: `part def VehicleController {
  doc /* Controls vehicle motion and safety systems */
  @meta { owner: "ControlsTeam", state: "active" }
  
  attribute maxSpeed : Real = 120.0;
  port sensorInput : SensorPort;
}`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Part Usage
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "part-usage",
    label: "Part Usage",
    description: "An instance of a part definition within a context",
    category: "structure",
    icon: "Package",
    fields: [
      nameField("Name", "mainController"),
      typeRefField("Type", "VehicleController"),
      multiplicityField,
      {
        id: "redefines",
        label: "Redefines",
        type: "text",
        required: false,
        placeholder: "parentPart",
        help: "Optionally redefine an inherited part",
        bestPractice: "Use redefinition to specialize inherited parts"
      },
      descriptionField
    ],
    generate: (v) => {
      const mult = v.multiplicity && v.multiplicity !== "1" ? `[${v.multiplicity}]` : "";
      const redef = v.redefines ? ` :>> ${v.redefines}` : "";
      let line = `part ${v.name} : ${v.typeRef}${mult}${redef};`;
      if (v.description) {
        line = `/* ${v.description} */
${line}`;
      }
      return line;
    },
    bestPractices: [
      "Use camelCase for instance names",
      "Specify multiplicity explicitly",
      "Choose meaningful names that describe the role"
    ],
    example: `part mainController : VehicleController[1];`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Attribute
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "attribute",
    label: "Attribute",
    description: "A property with a value type",
    category: "structure",
    icon: "Tag",
    fields: [
      nameField("Name", "maxSpeed"),
      {
        id: "attrType",
        label: "Type",
        type: "select",
        required: true,
        options: [
          { value: "Real", label: "Real", description: "Floating point number" },
          { value: "Integer", label: "Integer", description: "Whole number" },
          { value: "Boolean", label: "Boolean", description: "True/false value" },
          { value: "String", label: "String", description: "Text value" },
          { value: "custom", label: "Custom...", description: "Specify a custom type" }
        ],
        help: "The data type of this attribute"
      },
      {
        id: "customType",
        label: "Custom Type",
        type: "typeRef",
        required: false,
        placeholder: "MyEnumType",
        dependsOn: "attrType",
        help: "Specify when using a custom type"
      },
      {
        id: "hasDefault",
        label: "Has Default Value",
        type: "checkbox",
        required: false,
        defaultValue: false,
        help: "Whether to specify an initial value",
        bestPractice: "Provide defaults for required attributes"
      },
      {
        id: "defaultValue",
        label: "Default Value",
        type: "text",
        required: false,
        placeholder: "0.0",
        dependsOn: "hasDefault",
        help: "The initial value for this attribute"
      },
      {
        id: "unit",
        label: "Unit",
        type: "text",
        required: false,
        placeholder: "km/h",
        help: "Physical unit (optional but recommended)",
        bestPractice: "Always specify units for physical quantities"
      },
      descriptionField
    ],
    generate: (v) => {
      const type = v.attrType === "custom" ? v.customType : v.attrType;
      const unit = v.unit ? ` /* ${v.unit} */` : "";
      const defaultVal = v.hasDefault && v.defaultValue ? ` = ${v.defaultValue}` : "";
      let line = `attribute ${v.name} : ${type}${defaultVal};${unit}`;
      if (v.description) {
        line = `/* ${v.description} */
${line}`;
      }
      return line;
    },
    bestPractices: [
      "Use camelCase for attribute names",
      "Always specify units for physical quantities",
      "Provide default values where sensible",
      "Document constraints and valid ranges"
    ],
    example: `attribute maxSpeed : Real = 120.0; /* km/h */`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Port Definition
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "port-def",
    label: "Port Definition",
    description: "Defines an interface point for connections",
    category: "structure",
    icon: "Circle",
    fields: [
      nameField("Name", "SensorPort"),
      {
        id: "direction",
        label: "Direction",
        type: "select",
        required: true,
        defaultValue: "inout",
        options: [
          { value: "in", label: "In", description: "Receives data/signals" },
          { value: "out", label: "Out", description: "Sends data/signals" },
          { value: "inout", label: "In/Out", description: "Bidirectional" }
        ],
        help: "The data flow direction for this port",
        bestPractice: "Be explicit about direction for clarity"
      },
      {
        id: "conjugated",
        label: "Conjugated",
        type: "checkbox",
        required: false,
        defaultValue: false,
        help: "Flip the direction (for matching ports)",
        bestPractice: "Use conjugation for complementary port pairs"
      },
      descriptionField
    ],
    generate: (v) => {
      const conj = v.conjugated ? "~" : "";
      const lines = [];
      lines.push(`port def ${conj}${v.name} {`);
      if (v.description) {
        lines.push(`  doc /* ${v.description} */`);
      }
      lines.push(`  /* direction: ${v.direction} */`);
      lines.push("  ");
      lines.push("}");
      return lines.join("\n");
    },
    bestPractices: [
      'Use PascalCase with "Port" suffix for port definitions',
      "Be explicit about data flow direction",
      "Document what data/signals flow through the port"
    ],
    example: `port def SensorPort {
  doc /* Receives sensor readings */
  attribute reading : Real;
}`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Port Usage
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "port-usage",
    label: "Port Usage",
    description: "An instance of a port on a part",
    category: "structure",
    icon: "CircleDot",
    fields: [
      nameField("Name", "sensorIn"),
      typeRefField("Port Type", "SensorPort"),
      multiplicityField,
      descriptionField
    ],
    generate: (v) => {
      const mult = v.multiplicity && v.multiplicity !== "1" ? `[${v.multiplicity}]` : "";
      let line = `port ${v.name} : ${v.typeRef}${mult};`;
      if (v.description) {
        line = `/* ${v.description} */
${line}`;
      }
      return line;
    },
    bestPractices: [
      "Use camelCase with direction hint (e.g., sensorIn, dataOut)",
      "Place ports logically on the part boundary"
    ],
    example: `port sensorIn : SensorPort[1];`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Connection
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "connection",
    label: "Connection",
    description: "Links two ports together",
    category: "structure",
    icon: "Link",
    fields: [
      {
        id: "name",
        label: "Connection Name",
        type: "text",
        required: false,
        placeholder: "sensorLink",
        pattern: IDENTIFIER_PATTERN,
        patternMessage: IDENTIFIER_MESSAGE,
        help: "Optional name for this connection",
        bestPractice: "Name connections for complex wiring diagrams"
      },
      {
        id: "fromPart",
        label: "From Part",
        type: "text",
        required: true,
        placeholder: "sensor",
        help: "The source part name"
      },
      {
        id: "fromPort",
        label: "From Port",
        type: "text",
        required: true,
        placeholder: "dataOut",
        help: "The source port name"
      },
      {
        id: "toPart",
        label: "To Part",
        type: "text",
        required: true,
        placeholder: "controller",
        help: "The target part name"
      },
      {
        id: "toPort",
        label: "To Port",
        type: "text",
        required: true,
        placeholder: "sensorIn",
        help: "The target port name"
      },
      descriptionField
    ],
    generate: (v) => {
      const name = v.name ? `${v.name} ` : "";
      const from = `${v.fromPart}.${v.fromPort}`;
      const to = `${v.toPart}.${v.toPort}`;
      let line = `connection ${name}: ${from} -> ${to};`;
      if (v.description) {
        line = `/* ${v.description} */
${line}`;
      }
      return line;
    },
    bestPractices: [
      "Ensure port types are compatible",
      "Check direction compatibility (out -> in)",
      "Name complex connections for documentation"
    ],
    example: `connection sensorLink : sensor.dataOut -> controller.sensorIn;`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Requirement Definition
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "requirement-def",
    label: "Requirement",
    description: "A traceable system requirement",
    category: "requirements",
    icon: "CheckSquare",
    fields: [
      nameField("ID", "REQ_001"),
      {
        id: "title",
        label: "Title",
        type: "text",
        required: true,
        placeholder: "Maximum Speed Limit",
        help: "Short descriptive title",
        bestPractice: "Use clear, action-oriented titles"
      },
      {
        id: "text",
        label: "Requirement Text",
        type: "multiline",
        required: true,
        placeholder: "The system shall not exceed 120 km/h under normal operating conditions.",
        help: 'The formal requirement statement (use "shall" for requirements)',
        bestPractice: 'Use "shall" for mandatory requirements, "should" for recommendations'
      },
      {
        id: "priority",
        label: "Priority",
        type: "select",
        required: false,
        defaultValue: "medium",
        options: [
          { value: "critical", label: "Critical", description: "Must have for release" },
          { value: "high", label: "High", description: "Important for core functionality" },
          { value: "medium", label: "Medium", description: "Standard priority" },
          { value: "low", label: "Low", description: "Nice to have" }
        ],
        help: "Importance of this requirement"
      },
      {
        id: "rationale",
        label: "Rationale",
        type: "multiline",
        required: false,
        placeholder: "Safety regulations require speed limiting...",
        help: "Why this requirement exists",
        bestPractice: "Always document the rationale for traceability"
      },
      {
        id: "source",
        label: "Source",
        type: "text",
        required: false,
        placeholder: "ISO 26262, Customer Spec v2.1",
        help: "Where this requirement originated",
        bestPractice: "Track requirement sources for compliance"
      }
    ],
    generate: (v) => {
      const lines = [];
      lines.push(`requirement def ${v.name} {`);
      lines.push(`  doc /* ${v.title} */`);
      lines.push(`  `);
      lines.push(`  /* ${v.text} */`);
      if (v.priority || v.source) {
        const meta = [];
        if (v.priority) meta.push(`priority: "${v.priority}"`);
        if (v.source) meta.push(`source: "${v.source}"`);
        lines.push(`  @meta { ${meta.join(", ")} }`);
      }
      if (v.rationale) {
        lines.push(`  `);
        lines.push(`  /* Rationale: ${v.rationale} */`);
      }
      lines.push("}");
      return lines.join("\n");
    },
    bestPractices: [
      "Use consistent ID format (e.g., REQ_XXX)",
      "Write atomic, testable requirements",
      'Use "shall" for mandatory behavior',
      "Always include rationale for traceability",
      "Reference source documents"
    ],
    example: `requirement def REQ_001 {
  doc /* Maximum Speed Limit */
  
  /* The system shall limit vehicle speed to 120 km/h */
  @meta { priority: "high", source: "Safety Spec v1.0" }
  
  /* Rationale: Regulatory compliance */
}`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Constraint Definition
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "constraint-def",
    label: "Constraint",
    description: "A mathematical constraint or equation",
    category: "constraints",
    icon: "Equal",
    fields: [
      nameField("Name", "SpeedConstraint"),
      {
        id: "parameters",
        label: "Parameters",
        type: "text",
        required: true,
        placeholder: "speed, maxSpeed",
        help: "Comma-separated list of constraint parameters",
        bestPractice: "Use meaningful parameter names"
      },
      {
        id: "expression",
        label: "Constraint Expression",
        type: "text",
        required: true,
        placeholder: "speed <= maxSpeed",
        help: "The constraint equation or inequality",
        bestPractice: "Keep constraints simple and focused"
      },
      descriptionField
    ],
    generate: (v) => {
      const params = v.parameters.split(",").map((p) => p.trim()).filter(Boolean);
      const lines = [];
      lines.push(`constraint def ${v.name} {`);
      if (v.description) {
        lines.push(`  doc /* ${v.description} */`);
      }
      for (const param of params) {
        lines.push(`  in ${param} : Real;`);
      }
      lines.push(`  `);
      lines.push(`  ${v.expression}`);
      lines.push("}");
      return lines.join("\n");
    },
    bestPractices: [
      'Use PascalCase with "Constraint" suffix',
      "Document what the constraint enforces",
      "Keep constraints atomic and testable"
    ],
    example: `constraint def SpeedConstraint {
  doc /* Ensures speed stays within limits */
  in speed : Real;
  in maxSpeed : Real;
  
  speed <= maxSpeed
}`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // View Definition
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "view-def",
    label: "View",
    description: "A filtered view of model elements",
    category: "views",
    icon: "Eye",
    fields: [
      nameField("Name", "SafetyView"),
      {
        id: "filter",
        label: "Filter Expression",
        type: "text",
        required: false,
        placeholder: "*",
        defaultValue: "*",
        help: "What elements to include (use * for all)",
        bestPractice: "Create focused views for specific stakeholders"
      },
      {
        id: "stakeholder",
        label: "Stakeholder",
        type: "text",
        required: false,
        placeholder: "Safety Engineer",
        help: "Who this view is intended for",
        bestPractice: "Define views for each stakeholder group"
      },
      descriptionField
    ],
    generate: (v) => {
      const lines = [];
      lines.push(`view def ${v.name} {`);
      if (v.description) {
        lines.push(`  doc /* ${v.description} */`);
      }
      if (v.stakeholder) {
        lines.push(`  @meta { stakeholder: "${v.stakeholder}" }`);
      }
      lines.push(`  expose ${v.filter || "*"};`);
      lines.push("}");
      return lines.join("\n");
    },
    bestPractices: [
      "Create views for specific stakeholder concerns",
      "Use meaningful filter expressions",
      "Document what the view is intended to show"
    ],
    example: `view def SafetyView {
  doc /* Safety-critical components for safety review */
  @meta { stakeholder: "Safety Engineer" }
  expose *;
}`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Action Definition
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "action-def",
    label: "Action",
    description: "A reusable behavior definition",
    category: "behavior",
    icon: "Play",
    fields: [
      nameField("Name", "ProcessSensorData"),
      {
        id: "inputs",
        label: "Inputs",
        type: "text",
        required: false,
        placeholder: "rawData : SensorReading",
        help: "Input parameters (comma-separated)"
      },
      {
        id: "outputs",
        label: "Outputs",
        type: "text",
        required: false,
        placeholder: "processedData : FilteredReading",
        help: "Output parameters (comma-separated)"
      },
      descriptionField
    ],
    generate: (v) => {
      const lines = [];
      lines.push(`action def ${v.name} {`);
      if (v.description) {
        lines.push(`  doc /* ${v.description} */`);
      }
      if (v.inputs) {
        const inputs = v.inputs.split(",").map((i) => i.trim()).filter(Boolean);
        for (const input of inputs) {
          lines.push(`  in ${input};`);
        }
      }
      if (v.outputs) {
        const outputs = v.outputs.split(",").map((o) => o.trim()).filter(Boolean);
        for (const output of outputs) {
          lines.push(`  out ${output};`);
        }
      }
      lines.push("  ");
      lines.push("}");
      return lines.join("\n");
    },
    bestPractices: [
      "Use verb-noun naming (e.g., ProcessSensorData)",
      "Define clear inputs and outputs",
      "Keep actions focused on a single responsibility"
    ],
    example: `action def ProcessSensorData {
  doc /* Filters and validates sensor readings */
  in rawData : SensorReading;
  out processedData : FilteredReading;
}`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // State Definition
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "state-def",
    label: "State",
    description: "A state for state machines",
    category: "behavior",
    icon: "SquareStack",
    fields: [
      nameField("Name", "IdleState"),
      {
        id: "isInitial",
        label: "Initial State",
        type: "checkbox",
        required: false,
        defaultValue: false,
        help: "Is this the starting state?",
        bestPractice: "Every state machine needs exactly one initial state"
      },
      {
        id: "isFinal",
        label: "Final State",
        type: "checkbox",
        required: false,
        defaultValue: false,
        help: "Is this a terminal state?"
      },
      {
        id: "entryAction",
        label: "Entry Action",
        type: "text",
        required: false,
        placeholder: "initializeSystem",
        help: "Action to perform when entering this state"
      },
      {
        id: "exitAction",
        label: "Exit Action",
        type: "text",
        required: false,
        placeholder: "cleanupResources",
        help: "Action to perform when leaving this state"
      },
      descriptionField
    ],
    generate: (v) => {
      const initial = v.isInitial ? "initial " : "";
      const final = v.isFinal ? "final " : "";
      const lines = [];
      lines.push(`state def ${initial}${final}${v.name} {`);
      if (v.description) {
        lines.push(`  doc /* ${v.description} */`);
      }
      if (v.entryAction) {
        lines.push(`  entry ${v.entryAction};`);
      }
      if (v.exitAction) {
        lines.push(`  exit ${v.exitAction};`);
      }
      lines.push("}");
      return lines.join("\n");
    },
    bestPractices: [
      'Use descriptive state names ending in "State"',
      "Define entry/exit actions for state setup/cleanup",
      "Document what conditions cause state transitions"
    ],
    example: `state def initial IdleState {
  doc /* System waiting for input */
  entry initializeSystem;
}`
  }
];
function getSchemaById(id) {
  return ELEMENT_SCHEMAS.find((s) => s.id === id);
}
function getSchemasByCategory() {
  const result = {};
  for (const schema of ELEMENT_SCHEMAS) {
    if (!result[schema.category]) {
      result[schema.category] = [];
    }
    result[schema.category].push(schema);
  }
  return result;
}
function validateFields(schema, values) {
  const errors = {};
  const warnings = {};
  for (const field of schema.fields) {
    const value = values[field.id];
    if (field.required && (value === void 0 || value === null || value === "")) {
      errors[field.id] = `${field.label} is required`;
      continue;
    }
    if (field.dependsOn) {
      const depValue = values[field.dependsOn];
      if (!depValue || field.dependsOn === "attrType" && depValue !== "custom" || field.dependsOn === "hasDefault" && !depValue) {
        continue;
      }
    }
    if (field.pattern && typeof value === "string" && value) {
      if (!field.pattern.test(value)) {
        errors[field.id] = field.patternMessage || "Invalid format";
      }
    }
    if (typeof value === "string") {
      if (field.minLength && value.length < field.minLength) {
        errors[field.id] = `Must be at least ${field.minLength} characters`;
      }
      if (field.maxLength && value.length > field.maxLength) {
        errors[field.id] = `Must be at most ${field.maxLength} characters`;
      }
    }
  }
  return {
    valid: Object.keys(errors).length === 0,
    errors,
    warnings
  };
}
var CATEGORY_INFO = {
  structure: {
    label: "Structure",
    icon: "Boxes",
    description: "Define the static structure of your system"
  },
  behavior: {
    label: "Behavior",
    icon: "Play",
    description: "Define actions, states, and dynamic behavior"
  },
  requirements: {
    label: "Requirements",
    icon: "ClipboardCheck",
    description: "Capture and trace system requirements"
  },
  constraints: {
    label: "Constraints",
    icon: "Calculator",
    description: "Define mathematical constraints and equations"
  },
  views: {
    label: "Views",
    icon: "Eye",
    description: "Create filtered views for stakeholders"
  }
};
var INSERTION_POINTS = [
  {
    id: "cursor",
    label: "At Cursor",
    description: "Insert at the current cursor position",
    icon: "MousePointer"
  },
  {
    id: "end-of-file",
    label: "End of File",
    description: "Append at the end of the document",
    icon: "ArrowDown"
  },
  {
    id: "after-imports",
    label: "After Imports",
    description: "Insert after the last import statement",
    icon: "ArrowDownFromLine"
  },
  {
    id: "inside-package",
    label: "Inside Package",
    description: "Insert within the current package scope",
    icon: "PackagePlus"
  }
];

// src/builderTemplates.ts
var SYSML_TEMPLATES = [
  // ─────────────────────────────────────────────────────────────────────────
  // Structure Elements
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "part-def",
    label: "Part Definition",
    description: "Define a reusable structural element (block)",
    category: "structure",
    icon: "Box",
    keywords: ["block", "component", "element"],
    template: `part def $NAME$ {
  $CURSOR$
}`
  },
  {
    id: "part-usage",
    label: "Part Usage",
    description: "Create an instance of a part definition",
    category: "structure",
    icon: "Package",
    keywords: ["instance", "usage"],
    template: `part $NAME$ : $TYPE$;`
  },
  {
    id: "attribute",
    label: "Attribute",
    description: "Define a property with type and optional default",
    category: "structure",
    icon: "Tag",
    keywords: ["property", "field", "value"],
    template: `attribute $NAME$ : $TYPE$;`
  },
  {
    id: "attribute-with-default",
    label: "Attribute with Default",
    description: "Define a property with a default value",
    category: "structure",
    icon: "Tag",
    keywords: ["property", "field", "value", "default"],
    template: `attribute $NAME$ : $TYPE$ = $VALUE$;`
  },
  {
    id: "port-def",
    label: "Port Definition",
    description: "Define an interface point for connections",
    category: "structure",
    icon: "Circle",
    keywords: ["interface", "connector", "flow"],
    template: `port def $NAME$ {
  $CURSOR$
}`
  },
  {
    id: "port-usage",
    label: "Port Usage",
    description: "Create a port instance on a part",
    category: "structure",
    icon: "CircleDot",
    keywords: ["interface", "connector"],
    template: `port $NAME$ : $TYPE$;`
  },
  {
    id: "connection",
    label: "Connection",
    description: "Connect two ports together",
    category: "structure",
    icon: "Link",
    keywords: ["bind", "connect", "link"],
    template: `connection : $FROM$ -> $TO$;`
  },
  {
    id: "item-def",
    label: "Item Definition",
    description: "Define a data type or value object",
    category: "structure",
    icon: "FileCode",
    keywords: ["type", "data", "value"],
    template: `item def $NAME$ {
  $CURSOR$
}`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Behavior Elements
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "action-def",
    label: "Action Definition",
    description: "Define a reusable behavior",
    category: "behavior",
    icon: "Play",
    keywords: ["function", "method", "operation"],
    template: `action def $NAME$ {
  $CURSOR$
}`
  },
  {
    id: "action-usage",
    label: "Action Usage",
    description: "Execute an action within a context",
    category: "behavior",
    icon: "PlayCircle",
    keywords: ["execute", "perform", "call"],
    template: `action $NAME$ : $TYPE$;`
  },
  {
    id: "state-def",
    label: "State Definition",
    description: "Define a state for state machines",
    category: "behavior",
    icon: "SquareStack",
    keywords: ["state", "machine", "fsm"],
    template: `state def $NAME$ {
  $CURSOR$
}`
  },
  {
    id: "transition",
    label: "Transition",
    description: "Define a state transition",
    category: "behavior",
    icon: "ArrowRight",
    keywords: ["edge", "trigger", "guard"],
    template: `transition $NAME$ first $FROM$ then $TO$;`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Requirements
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "requirement-def",
    label: "Requirement Definition",
    description: "Define a traceable requirement",
    category: "requirements",
    icon: "CheckSquare",
    keywords: ["req", "shall", "specification"],
    template: `requirement def $NAME$ {
  doc /* $DESCRIPTION$ */
}`
  },
  {
    id: "requirement-usage",
    label: "Requirement Usage",
    description: "Reference a requirement in context",
    category: "requirements",
    icon: "Check",
    keywords: ["satisfy", "verify"],
    template: `requirement $NAME$ : $TYPE$;`
  },
  {
    id: "satisfy",
    label: "Satisfy Relationship",
    description: "Assert that an element satisfies a requirement",
    category: "requirements",
    icon: "CheckCircle",
    keywords: ["fulfill", "implement"],
    template: `satisfy $REQ$ by $ELEMENT$;`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Constraints
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "constraint-def",
    label: "Constraint Definition",
    description: "Define a reusable constraint equation",
    category: "constraints",
    icon: "Equal",
    keywords: ["equation", "formula", "math"],
    template: `constraint def $NAME$ {
  $LHS$ == $RHS$
}`
  },
  {
    id: "constraint-usage",
    label: "Constraint Usage",
    description: "Apply a constraint to elements",
    category: "constraints",
    icon: "Calculator",
    keywords: ["apply", "bind"],
    template: `constraint $NAME$ : $TYPE$ {
  $CURSOR$
}`
  },
  // ─────────────────────────────────────────────────────────────────────────
  // Views
  // ─────────────────────────────────────────────────────────────────────────
  {
    id: "view-def",
    label: "View Definition",
    description: "Define a filtered view of model elements",
    category: "views",
    icon: "Eye",
    keywords: ["filter", "query", "perspective"],
    template: `view def $NAME$ {
  expose *;
}`
  },
  {
    id: "viewpoint-def",
    label: "Viewpoint Definition",
    description: "Define stakeholder concerns and methods",
    category: "views",
    icon: "Target",
    keywords: ["stakeholder", "concern"],
    template: `viewpoint def $NAME$ {
  $CURSOR$
}`
  }
];
function getTemplatesByCategory() {
  const result = {};
  for (const template of SYSML_TEMPLATES) {
    if (!result[template.category]) {
      result[template.category] = [];
    }
    result[template.category].push(template);
  }
  return result;
}
var CATEGORY_INFO2 = {
  structure: { label: "Structure", icon: "Boxes" },
  behavior: { label: "Behavior", icon: "Play" },
  requirements: { label: "Requirements", icon: "ClipboardCheck" },
  constraints: { label: "Constraints", icon: "Calculator" },
  views: { label: "Views", icon: "Eye" }
};
function processTemplate(template) {
  let text = template.template;
  text = text.replace(/\$NAME\$/g, "untitled");
  text = text.replace(/\$TYPE\$/g, "UnknownType");
  text = text.replace(/\$VALUE\$/g, "0");
  text = text.replace(/\$DESCRIPTION\$/g, "Description here");
  text = text.replace(/\$FROM\$/g, "source");
  text = text.replace(/\$TO\$/g, "target");
  text = text.replace(/\$REQ\$/g, "requirement");
  text = text.replace(/\$ELEMENT\$/g, "element");
  text = text.replace(/\$LHS\$/g, "left");
  text = text.replace(/\$RHS\$/g, "right");
  const cursorIndex = text.indexOf("$CURSOR$");
  if (cursorIndex !== -1) {
    text = text.replace("$CURSOR$", "");
    return { text, cursorOffset: cursorIndex };
  }
  return { text, cursorOffset: null };
}
function searchTemplates(query) {
  if (!query.trim()) return SYSML_TEMPLATES;
  const lowerQuery = query.toLowerCase();
  return SYSML_TEMPLATES.filter((t) => {
    return t.label.toLowerCase().includes(lowerQuery) || t.description.toLowerCase().includes(lowerQuery) || t.category.toLowerCase().includes(lowerQuery) || t.keywords?.some((k) => k.toLowerCase().includes(lowerQuery));
  });
}
export {
  CATEGORY_INFO,
  ELEMENT_SCHEMAS,
  INSERTION_POINTS,
  SYSML_TEMPLATES,
  CATEGORY_INFO2 as TEMPLATE_CATEGORY_INFO,
  buildModelFromPackages,
  getSchemaById,
  getSchemasByCategory,
  getTemplatesByCategory,
  processTemplate,
  searchTemplates,
  validateFields
};
//# sourceMappingURL=index.js.map